import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';
import { DrNamedQuery } from './dr-named-query';
import { isNullOrUndefined } from './utils';

export enum DeDupScope {
    VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL'
}

export enum DeDupStrategy {
    FILE_DUPLICATION = 'FILE_DUPLICATION',
    MSG_CONTENT = 'MSG_CONTENT'
}

export enum EmailThreadingModes {
    RFC_2822_METADATA = 'RFC_2822_METADATA',
    MS_OTLOOK_METADATA = 'MS_OTLOOK_METADATA',
    CONTENT_BASED = 'CONTENT_BASED',
    SMF_CHAT_ID_BASED = 'SMF_CHAT_ID_BASED'
}

export enum CalendarDeDupStrategy {
    FILE_DUPLICATION = 'FILE_DUPLICATION',
    MSG_CONTENT = 'MSG_CONTENT'
}

export class AnalyticalSettings extends DrEntity {
    clusterWithStopWords: boolean;
    deDupScope: DeDupScope;
    deDupStrategy: DeDupStrategy;
    senderIncluded: boolean;
    additionalSenderIncluded: boolean;
    recipientIncluded: boolean;
    attachmentIncluded: boolean;
    sentDateIncluded: boolean;
    messageIdIncluded: boolean;
    autoThreading: boolean;
    caseDiscardCandidatesNamedQueries: Array<DrNamedQuery>;
    emailThreadingModes: Array<EmailThreadingModes>;
    suppressDuplicates: boolean;
    bccIncluded: boolean;
    calendarDeDupStrategy: CalendarDeDupStrategy;
    calendarSenderIncluded: boolean;
    additionalCalendarSenderIncluded: boolean;
    calendarRecipientIncluded: boolean;
    calendarAttachmentIncluded: boolean;
    calendarDateIncluded: boolean;
    facetsEnabled: boolean;
    messageAndAttachmentsScope: boolean;
    timezone: string;

    constructor(value?: Partial<AnalyticalSettings>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}


export class AnalyticalSettingsViewModel extends DrObject {

    model: Partial<AnalyticalSettings>;
    original: Partial<AnalyticalSettings>;

    constructor(value?: Partial<AnalyticalSettings>) {
        super(DrObjectType.EXCLUSION_SEARCH);
        if (value) {
            this.model = value;
        }

        if (this.model) {
            this.original = new AnalyticalSettings(this.model);
        }
    }

    isDirty(): boolean {
        const dirty = false;

        if (this.model.clusterWithStopWords !== this.original.clusterWithStopWords) {
            return true;
        }

        if (this.model.deDupScope !== this.original.deDupScope) {
            return true;
        }

        if (this.model.deDupStrategy !== this.original.deDupStrategy) {
            return true;
        }

        if (this.model.senderIncluded !== this.original.senderIncluded) {
            return true;
        }

        if (this.model.additionalSenderIncluded !== this.original.additionalSenderIncluded) {
            return true;
        }

        if (this.model.recipientIncluded !== this.original.recipientIncluded) {
            return true;
        }

        if (this.model.attachmentIncluded !== this.original.attachmentIncluded) {
            return true;
        }

        if (this.model.sentDateIncluded !== this.original.sentDateIncluded) {
            return true;
        }

        if (this.model.messageIdIncluded !== this.original.messageIdIncluded) {
            return true;
        }

        if (this.model.autoThreading !== this.original.autoThreading) {
            return true;
        }

        if (this.model.suppressDuplicates !== this.original.suppressDuplicates) {
            return true;
        }

        if (this.model.bccIncluded !== this.original.bccIncluded) {
            return true;
        }

        if (this.model.calendarDeDupStrategy !== this.original.calendarDeDupStrategy) {
            return true;
        }

        if (this.model.calendarSenderIncluded !== this.original.calendarSenderIncluded) {
            return true;
        }

        if (this.model.additionalCalendarSenderIncluded !== this.original.additionalCalendarSenderIncluded) {
            return true;
        }

        if (this.model.calendarRecipientIncluded !== this.original.calendarRecipientIncluded) {
            return true;
        }

        if (this.model.calendarAttachmentIncluded !== this.original.calendarAttachmentIncluded) {
            return true;
        }

        if (this.model.calendarDateIncluded !== this.original.calendarDateIncluded) {
            return true;
        }

        if (this.model.facetsEnabled !== this.original.facetsEnabled) {
            return true;
        }

        if (this.model.messageAndAttachmentsScope !== this.original.messageAndAttachmentsScope) {
            return true;
        }

        if (this.model.timezone !== this.original.timezone) {
            return true;
        }

        if ((!isNullOrUndefined(this.model.emailThreadingModes) || !isNullOrUndefined(this.original.emailThreadingModes))) {
            if (this.model.emailThreadingModes.length !== this.original.emailThreadingModes.length) {
                return true;
            }
        }

        return dirty;
    }
}

